import IconButton from "@pathwright/ui/src/components/button/IconButton"
import FullscreenConfirm from "@pathwright/ui/src/components/confirm/FullscreenConfirm"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import PropTypes from "prop-types"
import { Component } from "react"
import "./ManageContentHeader.css"

class ManageContentHeader extends Component {
  state = {
    confirmMethod: null
  }

  render() {
    const {
      methods,
      activeMethod,
      onEdit,
      isEditing,
      onSelectMethod,
      onClearMethod
    } = this.props

    return (
      <>
        {!!this.state.confirmMethod && (
          <FullscreenConfirm
            {...methods[this.state.confirmMethod].confirm}
            onConfirm={() => {
              return onSelectMethod(this.state.confirmMethod)
            }}
          />
        )}
        <div className="ManageContent__Header">
          <h3 className="ManageContent__HeaderTitle">
            <Pathicon
              icon={
                methods[activeMethod] ? methods[activeMethod].icon : undefined
              }
            />
            <span>
              {" "}
              {methods[activeMethod] ? methods[activeMethod].title : undefined}
            </span>
          </h3>
          {!isEditing && (
            <div className="ManageContent__HeaderControls">
              <IconButton icon="edit" size={30} onClick={onEdit} />
              <DropdownTrigger
                className="ManageContent__HeaderSwitch"
                renderDropdown={() => (
                  <DropdownMenu closeOnClick>
                    <label>Instead...</label>
                    {Object.entries(methods)
                      .filter(([key]) => key !== activeMethod)
                      .map(([key, value]) => (
                        <DropdownItem
                          key={key}
                          icon={value.icon}
                          label={value.title}
                          onClick={() => {
                            if (value.confirm) {
                              return this.setState({ confirmMethod: key })
                            }
                            return onSelectMethod.bind(null, key)
                          }}
                        />
                      ))}
                  </DropdownMenu>
                )}
              >
                <IconButton icon="chevron-down" size={32} />
              </DropdownTrigger>
            </div>
          )}
        </div>
      </>
    )
  }
}

ManageContentHeader.displayName = "ManageContentHeader"

ManageContentHeader.propTypes = {
  methods: PropTypes.objectOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      prompt: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onSelectMethod: PropTypes.func,
  onClearMethod: PropTypes.func,
  activeMethod: PropTypes.string
}

export default ManageContentHeader
